import { UserPlatformAccessRole } from "../../../utils/constants";

export const isAdmin = (privilegeType) => {
  return (
    privilegeType === UserPlatformAccessRole.ADMIN ||
    privilegeType === UserPlatformAccessRole.MSSP
  );
};

/**
 * Get the display email for a PlatformUser.
 * The fallback is here since we added the original_email field at some point,
 * at https://linear.app/breeze-security/issue/DEV-2668/add-the-original-email-to-the-platform-user.
 * And it doesn't exist for old PlatformUsers.
 */
export function getDisplayEmail(user) {
  return user?.original_email || user?.email;
}

// aligned with backend/access/router.py
export const ALLOWED_CHARACTERS_FOR_TEXT_INPUT = /^[a-zA-Z0-9_\-()/\\\s]+$/;

export const handleKeyDownForTextInput = (event) => {
  // Allow special keys (backspace, delete, arrows, etc.) - they have key length > 1
  if (event.key.length > 1) return;
  if (!ALLOWED_CHARACTERS_FOR_TEXT_INPUT.test(event.key)) {
    event.preventDefault();
  }
};
